import React from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

import {
  FormElement,
  InputText,
  INPUT_TEXT_VARIANT_DANGER
} from 'mailup-web-components'

import { modalCopyState } from '../recoil/state/modals'

const InputTitle = () => {
  const intl = useIntl()

  const { title } = useRecoilValue(modalCopyState)
  const setModalCopyState = useSetRecoilState(modalCopyState)

  const handleChangeTitle = ({ target: { value } }) => {
    setModalCopyState(prev => ({
      ...prev,
      title: value
    }))
  }

  const variant = title.trim().length ? undefined : INPUT_TEXT_VARIANT_DANGER

  return (
    <FormElement
      labelFor='templateTitle'
      label={intl.formatMessage({
        id: 'Load.Bee.CopyTemplateToListsLabelInput'
      })}
      required
    >
      <InputText
        value={title}
        onChange={handleChangeTitle}
        variant={variant}
        maxLength='50'
      />
    </FormElement>
  )
}

export default InputTitle
